import './App.css';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { useMemo, useState } from 'react';
import Home from './pages/Home';
import Stock from './pages/Stock';
import StockLog from './pages/StockLog';
import SalesStats from './pages/SalesStats';
import AddStock from './pages/AddStock';
import Ventoo from './pages/Ventoo';
import StockHistory from './pages/StockHistory';

function App() {
  const [selectedAccount, setSelectedAccount] = useState(
    localStorage.getItem('selected_account') || ''
  );

  const accountLabel = useMemo(() => {
    if (selectedAccount === 'aisdelu') return 'Aisdelu';
    if (selectedAccount === 'ventoo') return 'Ventoo';
    return '';
  }, [selectedAccount]);

  const chooseAccount = (account) => {
    localStorage.setItem('selected_account', account);
    setSelectedAccount(account);
    window.location.reload();
  };

  const resetAccount = () => {
    localStorage.removeItem('selected_account');
    setSelectedAccount('');
    window.location.reload();
  };

  if (!selectedAccount) {
    return (
      <div
        style={{
          minHeight: '100vh',
          background: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '520px',
            background: '#ffffff',
            borderRadius: '16px',
            padding: '28px',
            boxShadow: '0 12px 30px rgba(0,0,0,0.12)'
          }}
        >
          <h1 style={{ marginTop: 0, marginBottom: '10px', color: '#111827' }}>
            Alege firma
          </h1>
          <p style={{ marginTop: 0, marginBottom: '22px', color: '#4b5563' }}>
            Toate stocurile, scanarile si statisticile vor fi separate pe firma.
          </p>

          <div style={{ display: 'grid', gap: '14px' }}>
            <button
              type="button"
              onClick={() => chooseAccount('ventoo')}
              style={accountButtonStyle}
            >
              VENTOO
            </button>

            <button
              type="button"
              onClick={() => chooseAccount('aisdelu')}
              style={{ ...accountButtonStyle, background: '#1d4ed8' }}
            >
              AISDELU
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
        <nav
          style={{
            display: 'flex',
            gap: '12px',
            padding: '16px',
            background: '#111827',
            flexWrap: 'wrap',
            alignItems: 'center'
          }}
        >
          <Link style={linkStyle} to="/">
            Start vanzari
          </Link>

          <Link style={linkStyle} to="/add-stock">
            Intrare marfa
          </Link>

          <Link style={linkStyle} to="/stock">
            Stoc & aprovizionare
          </Link>

          <Link style={linkStyle} to="/stock-log">
            Istoric scanari
          </Link>

          <Link style={linkStyle} to="/stock-history">
            Istoric marfa
          </Link>

          <Link style={linkStyle} to="/sales-stats">
            Analiza vanzari
          </Link>

          <div
            style={{
              marginLeft: 'auto',
              display: 'flex',
              gap: '10px',
              alignItems: 'center',
              flexWrap: 'wrap'
            }}
          >
            <span
              style={{
                color: '#ffffff',
                background: '#374151',
                padding: '10px 14px',
                borderRadius: '8px',
                fontWeight: '700'
              }}
            >
              Firma: {accountLabel}
            </span>

            <button
              type="button"
              onClick={resetAccount}
              style={{
                color: '#ffffff',
                background: '#6b7280',
                border: 'none',
                padding: '10px 14px',
                borderRadius: '8px',
                fontWeight: '700',
                cursor: 'pointer'
              }}
            >
              Schimba firma
            </button>

            <Link style={ventooLinkStyle} to="/ventoo">
              VENTOO
            </Link>
          </div>
        </nav>

        <div style={{ padding: '20px' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/add-stock" element={<AddStock />} />
            <Route path="/stock" element={<Stock />} />
            <Route path="/stock-log" element={<StockLog />} />
            <Route path="/stock-history" element={<StockHistory />} />
            <Route path="/sales-stats" element={<SalesStats />} />
            <Route path="/ventoo" element={<Ventoo />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

const accountButtonStyle = {
  width: '100%',
  border: 'none',
  borderRadius: '12px',
  padding: '16px 18px',
  fontSize: '18px',
  fontWeight: '800',
  color: '#ffffff',
  background: '#059669',
  cursor: 'pointer'
};

const linkStyle = {
  color: '#ffffff',
  textDecoration: 'none',
  fontWeight: '600',
  padding: '10px 14px',
  borderRadius: '8px',
  background: '#1f2937'
};

const ventooLinkStyle = {
  color: '#ffffff',
  textDecoration: 'none',
  fontWeight: '800',
  padding: '10px 16px',
  borderRadius: '8px',
  background: '#059669',
  display: 'inline-block'
};

export default App;
